<style lang="css">
.account-search-box {
  position: absolute;
  right: 20px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}
</style>
<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-show="!isOnlyUser">
            <vxe-radio name="xtabs" label="tab1">选择企业用户列表</vxe-radio>
          </li>
          <li v-if="!notPer">
            <vxe-radio name="xtabs" label="tab2">选择个人用户列表</vxe-radio>
          </li>
          <li v-show="payType === 0">
            <vxe-radio name="xtabs" label="tab3">选择平台企业</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="account-search-box" style="display: flex;align-items: center;border:none;">
        <Button v-if="create && selectTab === 'tab1' && isHavePermission('user:company:create')" type="primary" @click="createComp"
                style="margin-right: 10px;border-radius: 4px;">创建企业用户
        </Button>
        <Button v-if="create && selectTab === 'tab2' && isHavePermission('user:person:create')" type="primary" @click="createPer"
                style="margin-right: 10px;border-radius: 4px;">创建个人用户
        </Button>
        <vxe-input
            style="height: 34px !important"
            v-model="username"
            type="text"
            :placeholder="selectTab === 'tab2' ? '姓名' : '企业名称'"
            clearable
        ></vxe-input>
        <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          :loading="loading"
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable1"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="companyData"
          @current-change="currentChangeEvent1"
      >
        <!--        <vxe-table-column field="userName" title="客户名称"></vxe-table-column>-->
        <vxe-table-column field="compName" title="企业名称"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page1.currentPage"
          :page-size.sync="page1.pageSize"
          :total="page1.totalResult"
          @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable2"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="personalData"
          @current-change="currentChangeEvent2"
      >
        <!--        <vxe-table-column field="userName" title="客户名称"></vxe-table-column>-->
        <vxe-table-column field="realName" title="姓名"></vxe-table-column>
        <vxe-table-column field="regisiterNum" title="手机号"></vxe-table-column>
        <vxe-table-column field="idcardNumSub" title="身份证尾号"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab3'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable3"
          class="table-style"
          height="430"
          :auto-resize="true"
          :data="companyplatData"
          @current-change="currentChangeEvent3"
      >
        <vxe-table-column field="name" title="企业名称"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page3.currentPage"
          :page-size.sync="page3.pageSize"
          :total="page3.totalResult"
          @page-change="changePage3"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: "Account",
  mixins: [getAuthOrization],
  props: {
    notPer: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      selectTab: "tab1",
      username: null,
      companyData: [],
      personalData: [],
      companyplatData: [],
      page1: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page3: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      isOnlyUser: false,
      isIdCardNum: false,
      payType: 1,
    };
  },
  created() {
  },
  methods: {
    createPer(){
      let obj = {
        name: `新建个人客户`,
        path: `/newUser/createPerson`
      };
      window.open(obj.path)
    },
    createComp(){
      let obj = {
        name: `新建企业客户`,
        path: `/newUser/createCompany`
      };
      window.open(obj.path);
    },
    initAccount(isOnlyUser, isIdCardNum) {
      if (isOnlyUser) {
        this.isOnlyUser = isOnlyUser;
        this.isIdCardNum = isIdCardNum
        this.selectTab = "tab2";
        this.username = null;
        this.page1.currentPage = 1;
        this.page2.currentPage = 1;
        this.queryPerUserList();
      }
    },
    changePage1(e) {
      this.page1.currentPage = e.currentPage;
      this.page1.pageSize = e.pageSize;
      this.queryCompUserList();
    },
    changePage2(e) {
      this.page2.currentPage = e.currentPage;
      this.page2.pageSize = e.pageSize;
      this.queryPerUserList();
    },
    changePage3(e) {
      this.page3.currentPage = e.currentPage;
      this.page3.pageSize = e.pageSize;
      this.queryCompanyPlatList();
    },
    currentChangeEvent1({row}) {
      this.$emit("choose", row, 1);
    },
    currentChangeEvent2({row}) {
      this.$emit("choose", row, 2);
    },
    currentChangeEvent3({row}) {
      this.$emit("choose", row, 0);
    },
    search() {
      if (this.selectTab === "tab1") {
        // 搜索企业用户列表
        this.page1.currentPage = 1;
        this.page1.pageSize = 10;
        this.queryCompUserList();
      } else if (this.selectTab === "tab2") {
        this.page2.currentPage = 1;
        this.page2.pageSize = 10;
        this.queryPerUserList();
      } else {
        this.page3.currentPage = 1;
        this.page3.pageSize = 10;
        this.queryCompanyPlatList();
      }
    },
    init(payType = 1) {
      this.isOnlyUser = false;
      this.payType = payType;
      this.selectTab = "tab1";
      this.username = null;
      this.page1.currentPage = 1;
      this.queryPerUserList();
      this.queryCompUserList();
      if (payType === 0) {
        this.queryCompanyPlatList()
      }
    },
    async queryPerUserList() {
      this.loading = true;
      let res = await $api.gcdUser.request("queryUserListWithoutPermission2", {
        username: this.username,
        userType: 1,
        orderBy: 2,
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page2.totalResult = res.data.total;
        this.personalData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryCompUserList() {
      this.loading = true;
      let res = await $api.gcdUser.request("queryUserListWithoutPermission", {
        username: this.username,
        userType: 2,
        orderBy: 2,
        page: this.page1.currentPage,
        rows: this.page1.pageSize,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page1.totalResult = res.data.total;
        this.companyData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryCompanyPlatList() {
      this.loading = true;
      // let res = await $api.department.get("listCompany", params);
      let res = await $api.department.get("listCompany", {
        name: this.username,
        userType: 1,
        orderBy: 2,
        page: this.page3.currentPage,
        rows: this.page3.pageSize
      });
      this.loading = false;
      if (res.status === 1) {
        this.page3.totalResult = res.data.total;
        this.companyplatData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    close() {
      this.selectTab = "tab1";
      this.username = null;
      this.page1 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.page2 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.page3 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.$refs.xTable1.clearCurrentRow();
      this.$refs.xTable2.clearCurrentRow();
      this.$refs.xTable3.clearCurrentRow();
    },
  },
};
</script>

<style></style>
